import { UserAudit } from 'types';

import { createCrudApi } from './crud.api';

export const userAuditApi = createCrudApi<UserAudit>('/user-audit');
